import { useQuery } from '@apollo/client';
import { GET_WALLPAPER } from '../component/GraphQL/Queries';

const useWallpaper=(wallpaperId)=>{
    const {data,error,loading}=useQuery(GET_WALLPAPER,{
        variables:{
            wallpaperId
        },
    });

    return {
        data,error,loading
    }
};

export default useWallpaper;